export const NumberGeneratorAllTR={
NuGeID:{en:'Generator ID',cs:'',dataType:'number',format:'#0',required:true},
NuGeName:{en:'Generator Name',cs:'',dataType:'string',required:true,maxLength:255},
NuGeCode:{en:'Generator Code',cs:'',dataType:'string',required:true,maxLength:50},
NuGeIsActive:{en:'Active',cs:'',dataType:'boolean',required:true},
NuGeTimeStamp:{en:'NuGeTimeStamp',cs:'NuGeTimeStamp',dataType:'number',format:'#0'},
NuGeSNGTID:{en:'NuGeSNGTID',cs:'NuGeSNGTID',dataType:'number',format:'#0',required:true},
SNGTName:{en:'SNGTName',cs:'SNGTName',dataType:'string',maxLength:255},
NGCVCounter:{en:'Sequence Counter',cs:'',dataType:'number',format:'#0'},
NGCVDateTime:{en:'NGCVDateTime',cs:'NGCVDateTime',dataType:'datetime',format:'dd.MM.yyyy HH:mm:ss'},
NGCVGenValue:{en:'Current Value',cs:'',dataType:'string',maxLength:100}
}